import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "card mb-5 mb-xl-10",
  id: "kt_profile_details_view"
}
const _hoisted_2 = { class: "card-header cursor-pointer" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "card-body p-9" }
const _hoisted_6 = { class: "row mb-7" }
const _hoisted_7 = { class: "col-lg-4 fw-bold text-muted" }
const _hoisted_8 = { class: "col-lg-8" }
const _hoisted_9 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_10 = { class: "row mb-7" }
const _hoisted_11 = { class: "col-lg-4 fw-bold text-muted" }
const _hoisted_12 = { class: "col-lg-8 fv-row" }
const _hoisted_13 = { class: "fw-bold fs-6" }
const _hoisted_14 = { class: "row mb-7" }
const _hoisted_15 = { class: "col-lg-4 fw-bold text-muted" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-exclamation-circle ms-1 fs-7",
  "data-bs-toggle": "tooltip",
  title: "Le numéro de téléphone doit être actif"
}, null, -1)
const _hoisted_17 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_18 = { class: "fw-bolder fs-6 me-2" }
const _hoisted_19 = { class: "badge badge-success" }
const _hoisted_20 = { class: "row mb-7" }
const _hoisted_21 = { class: "col-lg-4 fw-bold text-muted" }
const _hoisted_22 = { class: "col-lg-8" }
const _hoisted_23 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_24 = { class: "row mb-7" }
const _hoisted_25 = { class: "col-lg-4 fw-bold text-muted" }
const _hoisted_26 = { class: "col-lg-8" }
const _hoisted_27 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_28 = { class: "row mb-7" }
const _hoisted_29 = { class: "col-lg-4 fw-bold text-muted" }
const _hoisted_30 = { class: "col-lg-8" }
const _hoisted_31 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_32 = { class: "row mb-7" }
const _hoisted_33 = { class: "col-lg-4 fw-bold text-muted" }
const _hoisted_34 = { class: "col-lg-8" }
const _hoisted_35 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_36 = {
  key: 0,
  class: "notice d-flex bg-light-success rounded border-success border border-dashed p-6"
}
const _hoisted_37 = { class: "svg-icon svg-icon-2tx svg-icon-success me-4" }
const _hoisted_38 = { class: "d-flex flex-stack flex-grow-1" }
const _hoisted_39 = { class: "fw-bold" }
const _hoisted_40 = { class: "text-gray-800 fw-bolder" }
const _hoisted_41 = { class: "fs-6 text-gray-600" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.t("editProfile.profileDetails")), 1)
      ]),
      _createVNode(_component_router_link, {
        to: "/profile/settings",
        class: "btn btn-primary align-self-center"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t("editProfile.editProfile")), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.t("editProfile.fullname")), 1),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.firstName) + " " + _toDisplayString(_ctx.lastName), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.t("editProfile.birthday")), 1),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.moment(_ctx.birthday).format("l")), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("label", _hoisted_15, [
          _createTextVNode(_toDisplayString(_ctx.t("editProfile.telephoneNumber")) + " ", 1),
          _hoisted_16
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.phone), 1),
          _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.t("editProfile.verified")), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.t("editProfile.address")), 1),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.address), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.t("editProfile.cin")), 1),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.cin), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.t("editProfile.speciality")), 1),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.speciality), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.t("editProfile.civilstatus")), 1),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.civilstatus), 1)
        ])
      ]),
      (_ctx.updated)
        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
            _createElementVNode("span", _hoisted_37, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen043.svg" })
            ]),
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("h4", _hoisted_40, _toDisplayString(_ctx.t("editProfile.profileDetails")), 1),
                _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.t("editProfile.profileDetailsUpdated")), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}